import Modal from "../Modal/Modal";
import "./taskItem.css";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { useState } from "react";
function TaskItem({
  onClose,
  open,
  id,
  marka,
  product,
  minPay,
  minFollowers,
  completed,
}) {
  return (
    <Modal modalLable="Task Item" onClose={onClose} open={open}>
      <div className="taskItem">
        <h2>{marka}</h2>
        <p>{product}</p>
        <p>{minPay}</p>
        <p>{minFollowers}</p>
      </div>
    </Modal>
  );
}

export default TaskItem;
